<mat-icon
    *ngIf="
        config.iconPosition === 'left' &&
        config.icon &&
        config.iconType === 'default'
    "
>
    {{ config.icon }}
</mat-icon>
<mat-icon
    *ngIf="
        config.iconPosition === 'left' &&
        config.icon &&
        config.iconType === 'svg'
    "
    [svgIcon]="config.icon"
></mat-icon>
{{ config.title }}
{{ config.subText }}
<mat-icon
    *ngIf="
        config.iconPosition === 'right' &&
        config.icon &&
        config.iconType === 'default'
    "
>
    {{ config.icon }}
</mat-icon>
<mat-icon
    *ngIf="
        config.iconPosition === 'right' &&
        config.icon &&
        config.iconType === 'svg'
    "
    [svgIcon]="config.icon"
></mat-icon>
